document.addEventListener('DOMContentLoaded', function () {
  var form = document.getElementById('superpromo-form');
  if (!form) return;

  var inputM2 = document.getElementById('superpromo-m2');
  var inputQty = document.getElementById('superpromo-qty');
  var summary = document.getElementById('superpromo-summary');
  var errorBox = document.getElementById('superpromo-error');

  var packageM2 = parseFloat(form.dataset.packageM2 || '0');          // m² w paczce
  var availablePacks = parseFloat(form.dataset.availablePacks || '0'); // paczki w magazynie (inventory Shopify)
  //var minTail = parseFloat(form.dataset.minTail || '10');             // minimalny ogon m²

  function updateSummary() {
    errorBox.style.display = 'none';
    errorBox.textContent = '';

    var value = (inputM2.value || '').toString().replace(',', '.');
    var requestedM2 = parseFloat(value);

    if (isNaN(requestedM2) || requestedM2 <= 0 || packageM2 <= 0) {
      summary.textContent = '';
      return null;
    }

    // 1) Ile paczek potrzeba?
    var packages = Math.ceil(requestedM2 / packageM2);
    var realM2 = packages * packageM2;

    // 2) Nie można zamówić więcej paczek niż dostępne
    if (packages > availablePacks) {
      summary.textContent = '';
      errorBox.textContent = 'Brak wystarczającej ilości towaru na magazynie.';
      errorBox.style.display = 'block';
      return null;
    }

    // 3) Jaki ogon zostanie po zakupie?
    var tailPacks = availablePacks - packages;
    var tailM2 = tailPacks * packageM2;

    summary.textContent =
      'Zostanie dodane ' + packages + ' paczek (' +
      realM2.toFixed(2) + ' m²). ' +
      'Po zamówieniu na magazynie zostanie ok. ' + tailM2.toFixed(2) + ' m².';

    return {
      requestedM2: requestedM2,
      packages: packages,
      realM2: realM2,
      tailPacks: tailPacks,
      tailM2: tailM2
    };
  }

  inputM2.addEventListener('input', updateSummary);

  form.addEventListener('submit', function (e) {
    var calc = updateSummary();

    if (!calc) {
      e.preventDefault();
      if (!errorBox.textContent) {
        errorBox.textContent = 'Podaj prawidłową ilość w m².';
        errorBox.style.display = 'block';
      }
      return;
    }

    // Jeszcze raz: nie więcej paczek niż dostępnych
    if (calc.packages > availablePacks) {
      e.preventDefault();
      errorBox.textContent = 'Brak wystarczającej ilości towaru na magazynie.';
      errorBox.style.display = 'block';
      return;
    }
/*

    // Blokada ogona < 10 m² (wymóg z PDF)
    if (calc.tailM2 > 0 && calc.tailM2 < minTail) {
      e.preventDefault();
      errorBox.textContent =
        'Obowiązuje zasada minimalnej pozostałej ilości, tzn. ' +
        'na magazynie nie może pozostać końcówka mniej niż 10m2, ' +
        'dlatego prosimy o weryfikację ilości i złożenie odpowiednio ' +
        'zamówienia na pełną ilość.';
      errorBox.style.display = 'block';
      return;
    }
*/

    // Jeśli wszystko OK → wpisujemy liczbę paczek do quantity
    inputQty.value = calc.packages;
  });
});

// --- HORIZON FIX: remove native quantity inputs from Buy Buttons ---
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('input[name="quantity"]').forEach(function(el) {
    if (el.id !== 'superpromo-qty') {
      el.remove(); // usuwa duplikaty injectowane przez Shopify/Horizon
    }
  });
});